import {
  TopNavigation,
  TopNavigationProps,
} from '@amzn/awsui-components-console';
import { AppicationsItemIds, UserItemIds } from '@pages/constants';
import { useExternalModuleNavigate } from '@pages/hooks/externalNavigate';
import { useAppDispatch, useAppSelector } from '@stores/slices/hooks';
import {
  selectUsername,
  toggleSelectSite,
  toggleUserPreferences,
} from '@stores/slices/userSlice';
import * as React from 'react';
import { useNavigate } from 'react-router';

import whiteLogo from 'src/assets/logo_white.png';
import { CONSTANTS } from 'src/resources/constants';
import { AppPaths } from 'src/routes/Routes';
import {
  ariaLabels,
  elementIds,
  i18nStrings,
  labels,
  styles,
} from './constants';

/**
 *
 * Important Notes:
 * Do not use href attribute, as it cause reloading when navigation
 * Only use React Router <NavLink> or useNavigate to avoid react wasted rendering
 */
const MilestonesTopNav = (): React.ReactElement => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const username = useAppSelector(selectUsername);
  const { navigateToSecuMod } = useExternalModuleNavigate();

  const utilities: TopNavigationProps.Utility[] = [
    {
      type: 'button',
      text: labels.buttons.SELECT_SITES,
      iconName: 'edit',
      ariaLabel: ariaLabels.SELECT_SITES,
      badge: false,
      disableUtilityCollapse: true,
      onClick: (): void => {
        dispatch(toggleSelectSite());
      },
    },
    {
      type: 'menu-dropdown',
      text: 'Applications',
      items: [
        {
          id: AppicationsItemIds.Isc,
          text: 'ISC',
          ariaLabel: 'ISC',
        },
        {
          id: AppicationsItemIds.SecuMod,
          text: 'SecuMod',
          ariaLabel: 'SecuMod',
        },
      ],
      onItemClick: event => {
        switch (event.detail.id) {
          case AppicationsItemIds.Isc:
            navigate(AppPaths.Devices);
            break;
          case AppicationsItemIds.SecuMod:
            navigateToSecuMod();
            break;
        }
      },
    },
    {
      type: 'menu-dropdown',
      text: username,
      iconName: 'user-profile',
      items: [
        {
          id: UserItemIds.Preferences,
          text: 'Preferences',
          iconName: 'settings',
          ariaLabel: 'User Preferences',
        },
        {
          text: 'Help',
          items: [
            {
              id: UserItemIds.ReportBug,
              text: 'Report a Bug',
              href: CONSTANTS.REPORT_BUG,
              external: true,
              externalIconAriaLabel: ' (opens in new tab)',
            },
            {
              id: UserItemIds.FeatureRequest,
              text: 'Feature Requests',
              href: CONSTANTS.FEATURE_REQUEST,
              external: true,
              externalIconAriaLabel: ' (opens in new tab)',
            },
            {
              id: UserItemIds.UserGuide,
              text: 'End User Guide',
              href: CONSTANTS.WIKI_LINK,
              external: true,
              externalIconAriaLabel: ' (opens in new tab)',
            },
          ],
        },
      ],
      onItemClick: event => {
        switch (event.detail.id) {
          case UserItemIds.Preferences:
            dispatch(toggleUserPreferences());
            break;
        }
      },
    },
  ];

  return (
    <div
      className="awsui"
      id={elementIds.MILESTONES_TOP_NAVIGATION_ID}
      style={{
        position: 'sticky',
        top: 0,
        zIndex: styles.TOP_NAVIGATION_Z_INDEX,
      }}>
      <TopNavigation
        identity={{
          href: '#',
          onFollow: () => {
            navigate(AppPaths.Milestone);
          },
          title: labels.titles.TOP_NAVIGATION,
          logo: {
            src: whiteLogo,
            alt: labels.alt.LOGO,
          },
        }}
        utilities={utilities}
        i18nStrings={i18nStrings}
      />
    </div>
  );
};

export default MilestonesTopNav;
